import React, {useEffect} from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import {Link} from "react-router-dom";
import {Typography} from "@mui/material";
import {store} from "../../mobx/store";


const IndexPage: React.FC = () => {
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

        // Проверяем, есть ли UTM метки в URL
        let hasUtmParams = false;
        utmParams.forEach((value, key) => {
            if (urlParams.has(value)) {
                hasUtmParams = true;
                const param1 = urlParams.get(value);
                console.log(param1);
                if (param1 != null){
                    store.setReferer(param1)
                }
                urlParams.delete(value);  // Удаляем UTM метки
            }
        });

        // Если UTM метки были, изменяем URL без перезагрузки страницы
        if (hasUtmParams) {
            const newUrl = window.location.pathname + (urlParams.toString() ? `?${urlParams.toString()}` : '');
            window.history.replaceState({}, '', newUrl);  // Изменяем URL
        }
    }, []);

    return(
        <>
            <CssBaseline />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '80vh',
                }}
            >
                <Box sx={{ maxWidth: 800, margin: '0 auto', padding: 2 }}>
                    <Typography variant="h2" gutterBottom>
                        Хаккатон DigitalBerd
                    </Typography>

                    <Typography variant="body1" paragraph>
                        Уже который год ситуация в IT ухудшается: в компаниях идут сокращения, а устроиться на новую работу всё сложнее
                    </Typography>

                    <Typography variant="body1">
                        Фронты могут искать себе заказы на стороне - на фрилансе, бекендеры - переучиться в фулл стек и быть как фронты.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        У тех же, кто работает с данными (DE, DA, DS) при такой ситуации на рынке начинаются особо сильные проблемы - т.к. им искать заказы на стороне сложнее
                    </Typography>

                    <Typography variant="body1" paragraph>
                        Хаккатон посвящён как раз этой проблеме - как нам, специалистам по работе с данными найти заработок не в найме: искать частные заказы или создавать свой продукт
                    </Typography>

                    <Typography variant="body1" >
                        Соревнования будут проводиться онлайн: сейчас оглашаются правила, потом 3-4 месяца командам на разработку, и в мае команды проводят демо своих результатов
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Презентация результатов будет онлайн (как вы демо новых фич проводите в удалённой команде), по результатам демо будут выбраны команды победители в каждой номинации
                    </Typography>

                    <Typography variant="body1" >
                        Номинации будет две: ПРОДУКТ и УСЛУГА
                    </Typography>
                    <Typography variant="body1" >
                        Подробности в <Link to="/rules">правилах</Link>
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Так же все подробности можете смотреть тут: <a href="https://t.me/+lK17NXxEwB0wYmYy" target="_blank" rel="noopener noreferrer">Группа digitalberd - обсуждаем хаккатон</a>
                    </Typography>
                </Box>
            </Box>
        </>
    )
}

export default IndexPage;